export const enum SpecialGraphValues {
  MISSING = 'missing',
  OTHER = 'other',
}
